<template>
<div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
        <el-tabs>
            <!-- 参数设置 -->
            <el-tab-pane>
                <span slot="label"> {{ $t("logs.smartLearn1") }}</span>
                <div class="lie">
                    <table>
                        <tbody>
                            <tr>
                                <!-- 启用智能学习过滤 -->

                                <td>{{ $t("logs.smartLearn5") }}:</td>
                                <td>
                                    <el-checkbox-group v-model="smart_learn_check">
                                        <el-checkbox label=""></el-checkbox>
                                    </el-checkbox-group>
                                </td>
                            </tr>
                            <tr>
                                <!-- 智能学习最大邮件大小(KB) -->

                                <td>{{ $t("logs.smartLearn6") }}:</td>
                                <td>
                                    <el-input v-model="smart_learn_scan_max_msgsize" placeholder=""></el-input>
                                </td>
                            </tr>

                            <tr></tr>
                            <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="save_greylist()" :disabled="$root.jurisdiction.only_query==0">{{$t('logs.save_a')}}</el-button>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </el-tab-pane>

            <!-- 个性化设置 -->
            <el-tab-pane label="">
                <span slot="label"> {{ $t("logs.smartLearn2") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="tan_filter()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.smartLearn7") }}</el-button>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList2" :row-class-name="tableRowClassName">
                            <el-table-column prop="RECSEQ" :label="$t('logs.xuhao')"> </el-table-column>
                            <el-table-column prop="EMAIL" :label="$t('logs.smartLearn8')">
                            </el-table-column>

                            <el-table-column prop="address" :label="$t('logs.audit6')">
                                <template scope="scope">
                                    <!-- 删除 -->
                                    <el-button @click="del_filter(scope.$index, scope.row)" type="text" size="small" :disabled="$root.jurisdiction.only_query==0">{{ $t("table1.delete") }}</el-button>

                                </template>

                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_local_domain' }">
                        <!--  认证控制-->
                        <div class="pop_up_text pop_up_text_local_domain"><span class="span_pad"></span> {{$t('logs.smartLearn7')}}</div>
                        <p></p>
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    {{ $t("logs.smartLearn8") }} :
                                </div>
                                <div class="block block1">
                                    <el-input v-model="emailorip" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="save_filter()" :disabled="$root.jurisdiction.only_query == 0">{{$t('logs.save_a')}}</el-button>
                            <el-button type="danger" @click="off_filter()">{{$t('logs.save_b')}}</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>
            <!-- 正常列表 -->
            <!--<el-tab-pane label="正常列表">
                <span slot="label">{{ $t("logs.smartLearn3") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="tan()">{{ $t("logs.smartLearn9") }}</el-button>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table height="400" ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList3" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
                            <el-table-column type="selection" width="28" v-model="multipleSelection"></el-table-column>
                            <el-table-column prop="CREATE_DATE" :label="$t('logs.addt')">
                            </el-table-column>
                            <el-table-column prop="ENVFROM" :label="$t('logs.sand4_2')">
                            </el-table-column>
                            <el-table-column prop="SUBJECT" :label="$t('logs.sand4_1')"> </el-table-column>
                        </el-table>
                    </div>

                    <div class="pop-up" v-show="tanchu">
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">保存</el-button>
                            <el-button type="primary" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane>-->
            <!-- 垃圾列表 -->
            <!-- <el-tab-pane label="垃圾列表">
                <span slot="label"> {{ $t("logs.smartLearn4") }}</span>
                <div class="main">
                    <p>
                        <el-button @click="tan()">{{ $t("logs.smartLearn10") }}</el-button>
                    </p>
                </div>
                <div class="switch1">
                    <div class="table">
                        <el-table height="400" ref="multipleTable" tooltip-effect="dark" style="width: 100%" :data="fileList4" :row-class-name="tableRowClassName">
                            <el-table-column type="selection" width="28" v-model="multipleSelection1"></el-table-column>
                            <el-table-column prop="CREATE_DATE" :label="$t('logs.addt')">
                            </el-table-column>
                            <el-table-column prop="ENVFROM" :label="$t('logs.sand4_2')">
                            </el-table-column>
                            <el-table-column prop="SUBJECT" :label="$t('logs.sand4_1')"> </el-table-column>
                        </el-table>
                    </div>
                    <div class="pop-up" v-show="tanchu">
                        <div class="find">
                            <div class="find1">
                                <div class="find-text" style="padding-right:12px">
                                    策略用户:
                                </div>
                                <div class="block block1">
                                    <el-input v-model="input" placeholder=""></el-input>
                                </div>
                            </div>
                        </div>

                        <el-row>
                            <el-button type="primary" @click="tanSend()">保存</el-button>
                            <el-button type="primary" @click="tanOff()">取消</el-button>
                        </el-row>
                    </div>
                    <div class="gray" v-show="tanchu"></div>
                </div>
            </el-tab-pane> -->
        </el-tabs>
    </div>
</div>
</template>

<script>
// import $ from "jquery";
export default {
    data() {
        return {
            smart_learn_check: "",
            smart_learn_scan_max_msgsize: '',
            emailorip: '',
            textarea: "",
            input: "",
            time: new Date(2020, 9, 10, 18, 40),
            value1: "",

            tableData: [{
                address: "44",
            }, ],
            emali: "",
            value: "",
            checkList: [],
            tanchu: false,
            options: [{
                    value: "选项1",
                    label: "不使用TLS",
                },
                {
                    value: "选项2",
                    label: "增加信头标记",
                },
                {
                    value: "选项3",
                    label: "强制TLS",
                },
            ],
            checked: "",
            fileList2: [],
            fileList3: [],
            fileList4: [],
            radio: [],
            multipleSelection: [],
            multipleSelection1: [],
            data_loadok: '',
            // 总数
            totalnums: 0,
            size: 0,
            // 每页条数
            pagesize: 0,
            //   默认前往第几页
            page: 1,
        };
    },
    mounted() {
        this.getFileList1()
        // this.getFileList3()
        this.getFileList2()
        // this.getFileList4()
    },
    methods: {
        // 每页显示多少条 -- 切换
        handleSizeChange(val) {
            // console.log(`每页 ${val} 条`);
            this.pagesize = val;
            //  this.tanSend()

            // this.tanSend(this.search,this.pagesize)
            this.getFileList3();
        },
        // 当前第几页
        handleCurrentChange(val) {
            // console.log(`当前页: ${val}`);
            this.page = val;
            //  this.tanSend(this.search,this.pagesize)
            // console.log(this.page, '1111', val);
            this.getFileList3();
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
            console.log(this.multipleSelection, "table 框选中的值");
            // console.log(this.table);
        },
        del_filter(index, row) {
            // console.log(index, row)
            this.$confirm(`${this.$t('anti_gs1_tan.del')}`, {
                    confirmButtonText: `${this.$t('tan.confirm')}`,
                    cancelButtonText: `${this.$t('tan.cancel')}`,
                    type: "warning",
                })
                .then(() => {
                    let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
                    // console.log(sid);
                    let str = this.$qs.stringify({
                        __mode: "del_smart_learn_person",
                        sid: sid,

                        emailorip: row.EMAIL,

                    });
                    this.$axios
                        .post("/api/adm/cgi/aspam.cgi", str)
                        .then((res) => {
                            // console.log(res)
                            if (!res.data.fmstatus) {
                                alert(res.data);
                            } else if (res.data.fmstatus.code == "1") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "2") {
                                alert(res.data.fmstatus.errmsg);
                            } else if (res.data.fmstatus.code == "3") {
                                // alert(res.data.fmstatus.errmsg);
                                this.$router.push({
                                    name: "login",
                                });
                            } else {
                                this.getFileList2()
                                this.$message({
                                    type: "success",
                                    message: `${this.$t('anti_gs1_tan.del1')}`,
                                });
                            }
                        })
                })
                .catch(() => {
                    this.$message({
                        type: "info",
                        message: `${this.$t('anti_gs1_tan.del2')}`,
                    });
                });
        },
        save_filter() {
this.$save_hint_test();
this.$disable_hint_test();
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            let str = this.$qs.stringify({
                __mode: "save_smart_learn_person",
                sid: sid,

                emailorip: this.emailorip,

            });
            this.$axios
                .post("/api/adm/cgi/aspam.cgi", str)
                .then((res) => {
                    this.$close_hint_test();
                    this.$close_disable_hint_test();
                    console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false

                        this.getFileList2()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        save_greylist() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);
            let str = this.$qs.stringify({
                __mode: "save_smart_learn_param",
                sid: sid,
                smart_learn_check: this.smart_learn_check == true ? 1 : 0,
                smart_learn_scan_max_msgsize: this.smart_learn_scan_max_msgsize,
                data_loadok: this.data_loadok

            });
            this.$axios
                .post("/api/adm/cgi/aspam.cgi", str)
                .then((res) => {
                    // console.log(res);

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        // this.getFileList();
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu_edit = false

                        this.getFileList1()
                        this.$message({
                            type: "success",
                            message: `${this.$t('anti_gs1_tan.save_sueecss')}`,
                        });
                    }
                })
        },
        // 过滤单元加载
        getFileList4() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "load_smart_learn_list",
                        sid: sid,
                        as_spam: 1,
                        page: this.page,
                        pagesize: this.size

                    },
                })
                .then((res) => {
                    // console.log(res);

                   if(!res){
             this.loading = false;
          }
         else  if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList4 = res.data.ret.datalist
                        // this.totalnums = res.data.ret.total_num

                    }
                })
              
        },
        // 过滤单元加载
        getFileList3() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "load_smart_learn_list",
                        sid: sid,
                        as_spam: 2,
                        page: this.page,
                        pagesize: this.size

                    },
                })
                .then((res) => {
                    // console.log(res);

                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList3 = res.data.ret.datalist
                        // this.totalnums = res.data.ret.total_num

                    }
                })
              
        },
        // 个性化设置
        getFileList2() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "load_smart_learn_person",
                        sid: sid,
                    },
                })
                .then((res) => {
                    // console.log(res);

                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                        this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        // alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;
                        this.fileList2 = res.data.ret.datalist
                        this.defaut_pol_arr = res.data.ret.q_type
                        this.type_arr = res.data.ret.q_add_type
                        this.defaut_pol = res.data.ret.DFT_AUTHIP_RBLCHK
                        this.show_hint1 = res.data.ret.LOAD_HINT3

                    }
                })
              
        },
        // 过滤单元加载
        getFileList1() {
            this.loading = true;

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            this.$axios
                .get("/api/adm/cgi/aspam.cgi", {
                    params: {
                        __mode: "load_smart_learn_param",
                        sid: sid,
                    },
                })
                .then((res) => {
                    console.log(res);

                    if(!res){
             this.loading = false;
          }
         else if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "2") {
                       this.loading=false
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.loading = false;

                        this.smart_learn_scan_max_msgsize = res.data.ret.result.smart_learn_scan_max_msgsize
                        this.data_loadok = res.data.ret.ok
                        this.smart_learn_check = res.data.ret.result.smart_learn_check == 1 ? true : false

                    }
                })
              
        },
        // 显示
        tan: function () {
            this.tanchu = true;
        },
        tan_filter() {
            this.tanchu = true;
            this.emailorip = ''
        },
        off_filter() {
            this.tanchu = false;
        },
        // 打开关闭
        tanSend: function () {
            this.tanchu = false;
        },
        tanOff: function () {
            this.tanchu = false;
        },
        // 各行变色
        tableRowClassName({
            rowIndex
        }) {
            // console.log(row,rowIndex)
            if (rowIndex % 2 == 1) {
                return "warning-row";
                // console.log(2222)
            } else if (rowIndex % 2 !== 1) {
                return "success-row";
            }
            return "";
        },
    },
};
</script>

<style lang="less" scoped>
// .main {
//     display: flex;
//     align-items: center;
//     border: 1px solid #dcdfe6;
//     // background: #f1f1f1;
//     margin: 10px;

//     text-align: left;
//     //   margin-top: 20px;
// }

// .main p {
//     padding-left: 10px;
//     font-size: 14px;
//     line-height: 28px;
// }

@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";

/deep/ .lie tbody td:nth-child(1) {
    width: 270px;
}
</style>
